import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { User } from "../../../../types/types";
import UserCard, { UserCardLoader } from "../../../User/components/UserCard";

const NetworkListing = ({
  users,
  isLoading,
  hasActiveFilters,
}: {
  users?: User[];
  isLoading: boolean;
  hasActiveFilters: boolean;
}) => {
  if (isLoading)
    return (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(3, minmax(0, 1fr))" },
          gap: "16px",
          width: "100%",
          minWidth: 0,
        }}
      >
        {[...Array(9)].map((_, index) => (
          <UserCardLoader key={index} variant="grid" />
        ))}
      </Box>
    );
  if (!users || (users.length === 0 && hasActiveFilters)) return <NoFilteringResults />;
  if (!users || users.length === 0) return <NoConnections />;

  return <UsersList users={users} />;
};

export default NetworkListing;

const NoFilteringResults = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "network" });

  return (
    <Box
      sx={{
        padding: "24px",
      }}
    >
      <Typography
        sx={{
          color: "var(--Dark---1000, #111)",
          fontFamily: "Montserrat",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "20px",
          textAlign: "center",
        }}
      >
        {t("noFilteringResults")}
      </Typography>
    </Box>
  );
};

const NoConnections = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "network" });

  return (
    <Box
      sx={{
        padding: "24px",
      }}
    >
      <Typography
        sx={{
          color: "var(--Dark---1000, #111)",
          fontFamily: "Montserrat",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "20px",
          textAlign: "center",
        }}
      >
        {t("noConnections")}
      </Typography>
    </Box>
  );
};

const UsersList = ({ users }: { users: User[] }) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "repeat(2, 2fr)", sm: "repeat(3, minmax(0, 1fr))" },
        gap: "16px",
        width: "100%",
        minWidth: 0,
      }}
    >
      {users.map((user) => (
        <UserCard key={user.id} user={user} variant="grid" hasActions={true} />
      ))}
    </Box>
  );
};
